<!--
 * @Description:
-->
<template>
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>
<style lang="scss">
.el-menu-item:hover {
  outline: 0 !important;
  color: var(--el-color-primary) !important;
}

.el-submenu__title:focus, .el-submenu__title:hover {
  outline: 0 !important;
  color: #fff !important;
  background: var(--el-color-primary) !important;
  border-radius: 8px !important;
}

.el-menu-item:hover {
  outline: 0 !important;
  color: #fff !important;
  background: var(--el-color-primary) !important;
  border-radius: 8px !important;
}
.el-menu-item.is-active {
  color: var(--el-color-primary) !important; /* 导航栏颜色 */
}
.el-menu-item:focus, .el-menu-item:hover {
  outline: 0 !important;
  color: #fff !important;
  background: var(--el-color-primary) !important;
  border-radius: 8px !important;
}
</style>
